import styled, { css } from 'styled-components';
import { Link, Text, Grid } from '@sketch/components';
import { breakpoint } from '@sketch/global-styles';

const StyledLink = styled(Link) `
  display: block;
  margin-top: 24px;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.E};
`;
const FormContainer = styled.div `
  max-width: 400px;
  margin: 0 auto;
`;
const DimText = styled(Text).attrs({
    textStyle: 'copy.quaternary.standard.E',
}) `
  max-width: 400px;
  margin: 24px auto 0;
  text-align: center;

  ${StyledLink} {
    display: inline-block;
    margin: 0;
    color: ${({ theme }) => theme.colors.foreground.secondary.D};
  }
`;
const TextSignUp = styled.p `
  margin-top: 32px;
  font-size: ${({ theme }) => theme.fontSizes.E};
  text-align: center;
`;
const Line = styled.div `
  width: 100%;
  margin-top: 32px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.A};
`;
const StyledColumn = styled(Grid.Column) ``;
const StyledGrid = styled(Grid) `
  padding: 0 16px;
  width: auto;
  max-width: 960px;

  ${breakpoint('xs') `
    padding: 0 32px;
  `}

  ${StyledColumn} {
    max-width: 448px;
  }
`;
const Title = styled.h1(({ theme }) => css `
    margin: 0 0 16px 0;
    font-size: ${theme.fontSizes.I};
    line-height: 1;
  `);
const Subtitle = styled.p `
  margin-bottom: 24px;
`;
const Feature = styled.div `
  display: flex;
  align-items: top;
  margin-bottom: 12px;
  line-height: 1.4;
`;
const FeatureImg = styled.img `
  margin-right: 8px;
  width: 24px;
  height: 24px;
`;
const OperatingSystemWarning = styled(Text).attrs({
    textStyle: 'copy.quaternary.standard.C',
}) `
  text-align: center;
  margin-top: 12px;
`;
const RelatedContentTitle = styled.h1(({ theme }) => css `
    font-size: ${theme.fontSizes.F};
    font-weight: ${theme.fontWeights.medium};
    color: ${theme.colors.foreground.secondary.A};
    margin: 0;
  `);
const RelatedContentDescription = styled.p(({ theme }) => css `
    font-size: ${theme.fontSizes.E};
    font-weight: ${theme.fontWeights.regular};
    color: ${theme.colors.foreground.secondary.D};
    line-height: ${theme.lineHeights.E};
    margin: 4px 0 0 0;
  `);
const RelatedContentImg = styled.img(({ theme }) => css `
    width: 64px;
    height: 64px;
    margin-right: 16px;
    border-radius: ${({ theme }) => theme.radii.xlarge};
  `);
const RelatedContentLink = styled(Link) `
  display: flex;
  flex-direction: row;
  margin-top: 28px;
  white-space: break-spaces;

  :hover {
    ${RelatedContentTitle} {
      color: ${({ theme }) => theme.colors.foreground.secondary.C};
      text-decoration: underline;
    }
  }
`;
const FullWidthImage = styled.img `
  width: 100%;
  margin-top: 28px;
`;

export { DimText, Feature, FeatureImg, FormContainer, FullWidthImage, Line, OperatingSystemWarning, RelatedContentDescription, RelatedContentImg, RelatedContentLink, RelatedContentTitle, StyledColumn, StyledGrid, StyledLink, Subtitle, TextSignUp, Title };
